module.exports = __webpack_public_path__ + "static/media/mercabarna-4.15799116.jpg";